import { Box, Skeleton, Paper } from "@mui/material";

const COL_WIDTHS = [75, 65, 80, 55, 70, 85, 60, 72, 68, 78, 58, 82];

const TableSkeleton = ({ rows = 8, columns = 5 }) => {
  return (
    <Paper
      elevation={0}
      sx={{ mt: 3, borderRadius: 2, border: "1px solid", borderColor: "divider", overflow: "hidden" }}
    >
      {/* Header — matches teal MuiTableCell head */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: 2,
          px: 2,
          py: 1.5,
          bgcolor: "#0D9A8F",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} variant="text" height={24} width={i === 0 ? "40%" : "70%"} sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />
        ))}
      </Box>

      {/* Rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <Box
          key={rowIdx}
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: 2,
            px: 2,
            py: 1.4,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: rowIdx % 2 === 0 ? "transparent" : "grey.50",
            "&:last-child": { borderBottom: "none" },
          }}
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Skeleton
              key={colIdx}
              variant={colIdx === columns - 1 ? "rounded" : "text"}
              height={colIdx === columns - 1 ? 28 : 20}
              width={colIdx === columns - 1 ? 80 : `${COL_WIDTHS[colIdx % COL_WIDTHS.length]}%`}
            />
          ))}
        </Box>
      ))}

      {/* Pagination skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 2,
          px: 2,
          py: 1.5,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
      </Box>
    </Paper>
  );
};

export default TableSkeleton;
